// Components
// Hooks
import { formatTextWithComponent } from '@/utils/hooks/format/formatCaptionText/utils/formatTextWithComponents';

import { hashtagMentionsRegex } from '@/lib/regex';
// Libs
import { getOffsets } from '@/lib/scheduler/getOffsetFromCaption';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';
import H2 from '@/components/base/Headings/H2';
import { OffsetReplace } from '@/components/composite/TextFormatter';
// Types
import { GiveawayResult } from '@/components/pages/giveaway-picker/Types/drawTypes';

export const LeftBlock = ({ result }: { result: GiveawayResult }) => {
    const offsets = getOffsets(result.data.caption ?? '', hashtagMentionsRegex, [], 'instagram');
    const formattedCaption = formatTextWithComponent(result.data.caption ?? '', offsets);

    const ComponentsToPass = {
        ...offsets?.map((el, id) => (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
                key={id}
                href={el.link}
                className="text-icoBlue"
                target="_blank"
                rel="noopener noreferrer"
            />
        ))
    };

    return (
        <div
            className="flex w-full flex-col bg-icoGray-100 px-16 py-20 md:w-2/6 md:px-12 xl:px-24"
            data-testid="left-block">
            <div className="flex items-center gap-3">
                <Avatar
                    size="md"
                    url={result.data.owner?.profile_picture_url}
                    fallback={result.data.owner?.name?.[0]}
                />
                <H2 className="font-GSemiBold text-sm">{result.data.owner?.name}</H2>
            </div>
            <div>
                {/*eslint-disable-next-line @next/next/no-img-element*/}
                <img
                    src={result.data.image}
                    alt="Post"
                    className="my-4 h-auto w-full self-stretch rounded-m"
                />
                <p className="font-GMedium text-sm">
                    <OffsetReplace
                        text={formattedCaption}
                        components={{
                            br: <br />,
                            ...ComponentsToPass
                        }}
                    />
                </p>
            </div>
        </div>
    );
};
